<template>
  <div class="fill-height">
    <video ref="videoPlayer"
           v-show="sources.length"
           crossorigin="anonymous"
           class="video-js vjs-big-play-button vjs-big-play-centered CL__Video">
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank">
          supports HTML5 video
        </a>
      </p>
    </video>
    <pre v-if="1===2">{{ presentation }}</pre>
  </div>
</template>
<style lang="scss">
.CL__Video {
  width: 100%;
  height: 100% !important;;
  padding: 0 !important;
  flex: 1;
  display: flex;
  justify-content: center;
}
</style>
<script>
import {mapGetters} from 'vuex';
import videojs from 'video.js';
import '@videojs/http-streaming'; // MLD-7749
import videoEventTracking from 'videojs-event-tracking';
import 'video.js/dist/video-js.min.css';
import {find} from 'lodash';

// MLD-2739
videojs.registerPlugin('eventTracking', videoEventTracking);

export default {
  name: 'view-video-presentation',
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      player: null,
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'isAdmin',
      'isEmployee',
      'isMember',
      'isSuperAdmin',
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'activity',
      'activityID',
    ]),
    options() {
      return {
        autoplay: true,
        controls: true,
        plugins: {
          eventTracking: true,
        },
        sources: this.sources,
      }
    },
    sources() {
      const sources = [];
      const mainFile = find(this.presentation.files, f => f.path === 'presentation.mp4');
      if (mainFile) {
        sources.push({
          src: mainFile.url,
          type: mainFile.mime_type,
        })
      }
      return sources;
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      if (this.sources.length) {
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
          console.log('onPlayerReady', this);
        });

        this.player.on('tracking:firstplay', (e, data) => {

        });
        this.player.on('tracking:first-quarter', (e, data) => this.logVideoEvent(e.type, data, 25));
        this.player.on('tracking:second-quarter', (e, data) => this.logVideoEvent(e.type, data, 50));
        this.player.on('tracking:third-quarter', (e, data) => this.logVideoEvent(e.type, data, 75));
        this.player.on('tracking:fourth-quarter', (e, data) => this.logVideoEvent(e.type, data, 100));
        this.player.on('tracking:pause', (e, data) => this.logVideoEvent(e.type, data, null));
        this.player.on('tracking:seek', (e, data) => this.logVideoEvent(e.type, data, null));
        this.player.on('tracking:buffered', (e, data) => this.logVideoEvent(e.type, data, null));
        this.player.on('tracking:performance', (e, data) => this.logVideoEvent(e.type, data, null));
      }
    },
    logVideoEvent(eventName, eventData, progress) {
      console.log(eventName, progress);
      /*const mult = 1000000;
      eventData.meta = {
        progress: progress,
        currentTime: this.player.currentTime() * mult,
        duration: this.player.duration() * mult,
      };
      const data = {
        event_at_ms: Date.now(),
        category: 'Video',
        action: eventName,
        path: `${this.player.currentTime() * mult}`,
        data: eventData,
      };
      //console.log(eventName, eventData.meta);
      analyticsService.createEvent(this.sessionID, data);*/
    },
  }
}
</script>
